module.exports = {
  details: "Details",
  edit: "Edit",
  opera: "Operation",
  delete: "Delete",
  create: "New",
};
